import { isValidElement } from "react";

import type { IEmptyProps } from "@/components/atoms/Empty/types";
import EmptyState from "@/components/atoms/Icon/emptyState";
import { Paragraph } from "@/components/atoms/Paragraph";

const Empty = ({ title, description, icon }: IEmptyProps) => {
  const descElementOrText = isValidElement(description) ? (
    description
  ) : (
    <Paragraph size="small" type="secondary">
      {description}
    </Paragraph>
  );

  return (
    <div className="flex flex-col gap-1 items-center">
      <div className="flex flex-col gap-0.5 items-center">
        <div>{icon || <EmptyState />}</div>
        <Paragraph size="large" fontWeight="bold">
          {title}
        </Paragraph>
      </div>
      {description && descElementOrText}
    </div>
  );
};

export default Empty;
